import React from "react";
import { Route, Switch } from "react-router-dom";
import { isA, isReporter } from "../../store/utility";

import UserList from "./UserList";
import User from "./User";
/*import NewUser from "./NewUser";*/

const Users = () => (
  <Switch>
    <Route exact path="/users" component={UserList} />
    {isA() || isReporter ? (
      <Route exact path="/users/:number" component={User} />
    ) : null}
    {/*isA() || isReporter ? (<Route exact path='/users/:number/edit' component={EditUser}/>) : null*/}
  </Switch>
);

export default Users;



// WEBPACK FOOTER //
// ./src/containers/User/Users.js